module.exports = __webpack_public_path__ + "img/gbwhata-home.3c769aa8.webp";